//useMap

import { useQuery } from "@tanstack/react-query";
import { loadDashboard } from "../api/reportApi";

export function useMap(jobId, enabled) {

    return useQuery({
        queryKey: ["map", jobId],
        enabled,
        queryFn: async () => {

            const response = await loadDashboard(jobId);

            //console.log("RAW CODEBASE MAP:", response);
            //console.log("ONE HOTSPOT:", response?.worstFiles?.data?.repositoryFiles?.[0]);

            return response?.worstFiles?.data?.repositoryFiles || [];
        }
    });
}